/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wide_Fond_Ape_FlyInputs */

const en_wide_fond_ape_fly = /** @type {(inputs: Wide_Fond_Ape_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start import`)
};

const de_wide_fond_ape_fly = /** @type {(inputs: Wide_Fond_Ape_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import starten`)
};

/**
* | output |
* | --- |
* | "Start import" |
*
* @param {Wide_Fond_Ape_FlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wide_fond_ape_fly = /** @type {((inputs?: Wide_Fond_Ape_FlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wide_Fond_Ape_FlyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wide_fond_ape_fly(inputs)
	return de_wide_fond_ape_fly(inputs)
});